<!-- eslint-disable vue/no-template-key -->
<template>
  <div class="payment-inquiry-container">
    <BaseStaffQrCode />
    <Button
      depressed
      color="color-bnn"
      :disabled="disabledButton"
      :loading="isLoading"
      :title="label"
      @click="handleInquiryRequest"
    />
  </div>
</template>

<script>
import moment from 'moment'
import colorBnn from '@/config/color'

export default {
  name: 'PaymentGuaranteeInquiry',

  components: {
    BaseStaffQrCode: () =>
      import('@/components/base/BaseStaffQrCode'),
    Button: () => import('@/components/bnn/Button'),
  },

  computed: {
    isLoading() {
      return this.$store.getters['order/isLoading']('submit')
    },
    isSuccess() {
      return this.$store.getters['order/isSuccess']('submit')
    },
    label() {
      return `ตรวจสอบสถานะ ${
        this.countDown > 0 ? `(${this.countDown}วิ)` : ''
      }`
    },
    disabledButton() {
      return this.countDown > 0
    },
  },

  async mounted() {
    if (localStorage.getItem('timeUntilNextRequest')) {
      this.countDown = moment
        .unix(localStorage.getItem('timeUntilNextRequest'))
        .diff(moment(), 'seconds')

      this.countDownTimer()
    }
  },

  data() {
    return {
      colorBnn,

      countDown: 0,
      countDownInterval: null,
    }
  },

  methods: {
    countDownTimer() {
      // Clear existing interval if any
      if (this.countDownInterval) {
        clearInterval(this.countDownInterval)
      }

      this.countDownInterval = setInterval(() => {
        this.countDown = moment
          .unix(localStorage.getItem('timeUntilNextRequest'))
          .diff(moment(), 'seconds')

        if (this.countDown <= 0) {
          localStorage.removeItem('timeUntilNextRequest')
          clearInterval(this.countDownInterval)
        }
      }, 1000)
    },

    async handleInquiryRequest() {
      const uuid = this.$route.params.uid

      if (!uuid) return

      try {
        await this.$store.dispatch(
          'order/inquiryTransactionRequest',
          uuid,
        )
        if (this.isSuccess) {
          localStorage.setItem(
            'timeUntilNextRequest',
            moment()
              .add(31, 'seconds')
              .unix(),
          )
          this.countDown = moment
            .unix(localStorage.getItem('timeUntilNextRequest'))
            .diff(moment(), 'seconds')
          this.countDownTimer()
        }
        if (this.isError) {
          this.$emit('error')
        }
      } catch {
        this.$emit('error')
      }
    },
  },
}
</script>

<style lang="stylus" scoped>
.payment-inquiry-container {
    display flex;
	flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 16px;

	::v-deep .staff-qr-code-container {
		order: 1
	}

    @media screen and (min-width: 768px) {
	    flex-direction: row;
        justify-content: space-between;

		::v-deep .staff-qr-code-container {
			order: 0
		}
    }

	.btn-link {
		font-weight: 600;
		font-size: 14px;
	}
}
</style>
